<script setup>
import { inject } from 'vue';

defineProps({
    name: {
        type: String,
        required: true,
    },
    as: {
        required: false,
    }
});

const form = inject('form');
</script>

<template>
    <component
        :is="as ? as : 'button'"
        :type="as ? undefined : 'button'"
        class="relative"
        @click="form.getField(name).getComponent().selectFile()">
        <slot />
    </component>
</template>
